/**
 * @fileoverview Module for `src/dashboard/manage-letters/common/SlideOutRow.js`.
 */

import PropTypes from 'prop-types';
import DownloadButton from './DownloadButton';
import StatusChangeButton from './StatusChangeButton';

/**
 * Renders status actions and download controls for one expanded letter row.
 *
 * @param {Object} params
 * @returns {JSX.Element} Slide-out row with transition controls.
 */
function SlideOutRow({
  children,
  lettersToMutate,
  downloadState,
  segmentTrackIds,
  downloadIconOnly = false,
  mailOnDate,
  modifyAndDownloadState,
  isReady,
  status,
}) {
  const statusNames = {
    unprepped: {
      name: 'unprepared',
    },
    prepped: {
      name: 'prepared',
    },
    sent: {
      name: 'sent',
    },
  };
  const statusName = statusNames[status.toLowerCase()].name;
  const segmentTrackProperties = { ...segmentTrackIds, previousState: statusName };

  return (
    <div className='row letter-item bundle-cell-contents'>
      <StatusChangeButton
        isBackwardMutation
        isReady={ isReady }
        lettersToMutate={ lettersToMutate }
        modifyAndDownloadState={ modifyAndDownloadState }
        segmentTrackPropeties={ segmentTrackProperties }
        status={ status }
      />
      { children }
      <DownloadButton
        downloadState={ downloadState }
        isIconOnly={ downloadIconOnly }
        isReady={ isReady }
        modifyAndDownloadState={ modifyAndDownloadState }
      />
      <StatusChangeButton
        isReady={ isReady }
        lettersToMutate={ lettersToMutate }
        mailOnDate={ mailOnDate }
        modifyAndDownloadState={ modifyAndDownloadState }
        segmentTrackPropeties={ segmentTrackProperties }
        status={ status }
      />
    </div>
  );
}

SlideOutRow.propTypes = {
  children: PropTypes.any.isRequired,
  downloadIconOnly: PropTypes.bool,
  downloadState: PropTypes.object.isRequired,
  isReady: PropTypes.bool.isRequired,
  lettersToMutate: PropTypes.array.isRequired,
  mailOnDate: PropTypes.string.isRequired,
  modifyAndDownloadState: PropTypes.object.isRequired,
  segmentTrackIds: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
};

export default SlideOutRow;
